import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
} from '@angular/core';
import { ICustomReportFilter } from '@principle-theorem/principle-core/interfaces';
import {
  CustomReportFilter,
  ReportBuilderDataSourceInstance,
} from '@principle-theorem/reporting';
import { EditReportFilterBooleanComponent } from './edit-report-filter-boolean/edit-report-filter-boolean.component';
import { EditReportFilterDateComponent } from './edit-report-filter-date/edit-report-filter-date.component';
import { EditReportFilterNumberComponent } from './edit-report-filter-number/edit-report-filter-number.component';
import { EditReportFilterSelectComponent } from './edit-report-filter-select/edit-report-filter-select.component';
import { EditReportFilterStringComponent } from './edit-report-filter-string/edit-report-filter-string.component';

@Component({
  selector: 'pr-edit-report-filter',
  templateUrl: './edit-report-filter.component.html',
  styleUrls: ['./edit-report-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    EditReportFilterNumberComponent,
    EditReportFilterBooleanComponent,
    EditReportFilterSelectComponent,
    EditReportFilterStringComponent,
    EditReportFilterDateComponent,
  ],
})
export class EditReportFilterComponent {
  dataSource = input.required<ReportBuilderDataSourceInstance>();
  filter = input<ICustomReportFilter>();
  filterChange = output<Partial<ICustomReportFilter>>();

  config = computed(() => {
    const filter = this.filter();
    return filter
      ? CustomReportFilter.getProperty(this.dataSource().factTable, filter)
          ?.metadata
      : undefined;
  });
}
